import { combineReducers } from 'redux';
import { createTransform, PersistConfig, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { deserialise, serialise } from '../../utils/Serialiser';
import { dataReducer } from './DataReducer';
import foldersReducer from './folders';
import ordersReducer from './orders';
import { userReducer } from './UserReducer';
import ordersByIdReducer from "./ordersById";
import basketReducer from "./basket";
import parametersReducer from "./parameters";
import optionsBySubsetId from './optionsBySubsetId';
import setsReducer from "./sets";

/**
 * redux-persist serialises the store with JSON, which doesn't support maps.
 * Hence we use custom serialisation here which supports basic maps
 * (i.e. those without object keys)
 */
const mapTransformer = createTransform(
  inboundState => serialise(inboundState),
  outboundState => deserialise(outboundState),
  {}
);

const basketPersistConfig: PersistConfig = {
  key: 'shopping-cart::basket',
  storage,
  transforms: [mapTransformer]
}

const reducers = {
  basket: persistReducer(basketPersistConfig, basketReducer),
  folders: foldersReducer,
  orders: ordersReducer,
  ordersById: ordersByIdReducer,
  parameters: parametersReducer,
  sets: setsReducer,
  subsetOptionsBySubsetId: optionsBySubsetId,
  data: dataReducer,
  user: userReducer
};

/**
 * The root reducer for the whole store.
 * It is configured to be used with redux-persist.
 */
export const rootReducer = combineReducers(reducers);
export type TRootState = ReturnType<typeof rootReducer>;
